
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Students Scholarship</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      

<section class="section-lg std-scholarship">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10">
                <div class="main-timeline">
                    <div class="timeline" >
                        <div class="timeline-content" >
                            <div class="timeline-icon"><i class="fa fa-graduation-cap" aria-hidden="true"></i></div>
                            <div class="inner-title"  >
                                <h5>A) Scholarship received from Samaj Kalyan</h5>
                               
                            </div>
                            <ul class="list-item">
                                <li>Post metric scholarship run by Maharashtra government (www.mahadbtmahait.gov.in)</li>
                                <li>This scholarship is only for SC/ ST candidates who have cleared their 12th exams</li>
                                <li> This scholarship is for both the courses – BBA & BCCA</li>
                            </ul>
                        </div>
                    </div>
                    <div class="timeline" >
                        <div class="timeline-content">
                            <div class="timeline-icon"><i class="fa fa-graduation-cap"></i></div>
                            <div class="inner-title"  >
                                <h5>B) Minority based scholarship( Jain, Christian, Sikh, Muslim)</h5>
                               
                            </div>
                            <ul class="list-item">
                                <li>Criteria – 50% marks in previous exam</li>
                                <li>Rs 2.5 lakhs minimum income</li>
                                <li> Minority certificate and domicile required</li>
                            </ul>
                        </div>
                    </div>
                    <div class="timeline" >
                        <div class="timeline-content">
                            <div class="timeline-icon"><i class="fa fa-graduation-cap"></i></div>
                            <div class="inner-title"  >
                                <h5>C) Raisoni Group of Institutions – Scholarship details</h5>	
                               
                            </div>
                            <ul class="list-item">
                                <li>Merit based scholarship is available based on academic performance up to 20% of total fees for BBA & up to 10% of total fees for BCCA</li>
                                <li>Siblings concessions is available & Alumni concessions are also provided</li>
                            </ul> 
                        </div>
                    </div>
                </div>               
            </div>
        </div>
    </div>
</section>

